<template>
  <div class="avilable-times">
    <h2 class="title">
      {{$t('Time Slots')}}
    </h2>
    <p class="secondary--text text-center" v-if="!selectedDate" style="margin-top: 65px">
      {{$t('No appointments available')}}
    </p>
    <p v-if="selectedDate && !availableSlots.length" class="text-center" style="margin-top: 50px">
      {{$t('No appointments available')}}
    </p>
    <v-item-group v-else v-model="selectedTime" class="slots-button" @change="changeTime">
      <v-item v-for="(time, index) in availableSlots" :key="index"  v-slot="{ active, toggle }">
        <v-btn @click="toggle"   large :disabled="!time.available" :color="active ? 'primary': 'secondary'" :dark="!!active" outlined :value="time">
          {{time.time}}  

          <span v-if="availableSlots[index+1]">
            - {{ availableSlots[index+1].time }}
          </span>
        </v-btn>
      </v-item>
    </v-item-group>
  </div>
</template>

<script>
export default {
  name: "allowedTimes",
  props: {
    availableSlots: {
      type: Array,
      default: ()=> {
        return []
      }
    },
    selectedDate: {
      type: String,
      default: ()=> {
        return null
      }
    }
  },
  data() {
    return {
      selectedTime: null
    }
  },
  methods: {
    changeTime () {
      this.$emit('changeTime', this.availableSlots[this.selectedTime].time)
    }
  }
}
</script>

<style scoped lang="scss">
.avilable-times {
  border-radius: 10px;
  box-shadow: 0px 4px 14px 0px #D9D9D973;
  height: 100%;
  margin: 14px;
  padding: 24px 16px;

  .title {
    color: var(--secondaryColor);
    font-size: 16px;
    font-weight: 600;
    margin-bottom: 16px;
  }
}

.slots-button {
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  justify-content: center;
  width: 100%;
  max-height: calc(100vh - 500px) !important;
  overflow-y: auto;

  .v-btn {
    background: #F2F5FD;
    border: none;
    border-radius: 10px;
    box-sizing: border-box;
    color: var(--secondaryColor);
    font-size: 12px;
    font-weight: 400;
    height: 38px;
    letter-spacing: 0;
    width: calc(50% - 6px) !important;

    &.v-item--active {
      background: var(--secondaryColor) !important;
      color: white !important;
    }

    &.theme--dark {
      color: white !important;
    }
  }
}

@media screen and (max-width: 959px) {
  .avilable-times {
    box-shadow: none;
  }
}
</style>
